import { render, staticRenderFns } from "./InvitationList.vue?vue&type=template&id=d7c1c5f0&scoped=true&"
import script from "./InvitationList.vue?vue&type=script&lang=js&"
export * from "./InvitationList.vue?vue&type=script&lang=js&"
import style0 from "./InvitationList.vue?vue&type=style&index=0&id=d7c1c5f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7c1c5f0",
  null
  
)

export default component.exports